const borderRadius = '1rem'; // old value -> 0.28571429rem

export default borderRadius;
